"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var Slider_1 = tslib_1.__importDefault(require("../../components/Slider"));

var propTypes_1 = require("../../propTypes");

var utilities_1 = require("../../utilities");

var Item_1 = tslib_1.__importDefault(require("./Item"));

var Paging_1 = require("./Paging");

var SliderContainer = styled_components_1["default"]('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"])));
var Link = styled_components_1["default"]('a')(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));

function quantize(num) {
  var div = num / 100;
  var base = Math.floor(div);

  if (div > base) {
    return (base + 1) * 100;
  }

  return base * 100;
}

var WidgetArticleSlider =
/** @class */
function (_super) {
  tslib_1.__extends(WidgetArticleSlider, _super);

  function WidgetArticleSlider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      imageWidth: 0
    };
    _this.wrapperEl = null;

    _this.handleResize = function () {
      if (_this.wrapperEl) {
        window.clearTimeout(_this.timeout);
        _this.timeout = window.setTimeout(function () {
          var containerWidth = _this.wrapperEl.getBoundingClientRect().width;

          _this.setState({
            imageWidth: quantize(containerWidth)
          });
        }, 100);
      }
    };

    return _this;
  }

  WidgetArticleSlider.prototype.componentDidMount = function () {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  WidgetArticleSlider.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.handleResize);
    window.clearTimeout(this.timeout);
  };

  WidgetArticleSlider.prototype.render = function () {
    var _this = this;

    var getArticleUrl = this.props.getArticleUrl;
    var imageWidth = this.state.imageWidth;
    var articles = sportnet_utilities_1.getProp(this.props, ['data', 'data', 'articleFilter', 'articles'], []);

    if (articles.length === 0) {
      return null;
    }

    var sliderSettings = {
      dots: false,
      slidesToShow: 1,
      swipeToSlide: true,
      arrows: true,
      slide: 'a',
      infinite: true,
      prevArrow: react_1["default"].createElement(Paging_1.PrevArrow, {
        containerWidth: imageWidth
      }),
      nextArrow: react_1["default"].createElement(Paging_1.NextArrow, {
        containerWidth: imageWidth
      }),
      autoplay: true
    };
    return react_1["default"].createElement(SliderContainer, {
      ref: function (el) {
        _this.wrapperEl = el;
      }
    }, react_1["default"].createElement(Slider_1["default"], tslib_1.__assign({}, sliderSettings), articles.map(function (article) {
      return react_1["default"].createElement(Link, {
        key: article._id,
        href: getArticleUrl(article),
        draggable: false
      }, react_1["default"].createElement(Item_1["default"], {
        title: article.name,
        maxWidth: imageWidth,
        picture: article.picture
      }));
    })));
  };

  return WidgetArticleSlider;
}(react_1.PureComponent);

WidgetArticleSlider.propTypes = {
  data: prop_types_1["default"].shape({
    data: {
      articleFilter: {
        articles: propTypes_1.ArticlePropType
      }
    }
  }).isRequired,
  getArticleUrl: prop_types_1["default"].func
};
WidgetArticleSlider.defaultProps = {
  getArticleUrl: utilities_1.getArticleUrl
};
exports["default"] = WidgetArticleSlider;
var templateObject_1, templateObject_2;